import moment from 'moment'
import pdfIcon from '@/util/pdf-icon-64'
import router from '@/router'
import { months } from '@/util/SelectLists'

const appStatus = [
  'Accepted',
  'Confirmed',
  'Rejected',
  'Declined'
]

const initState = () => ({
  isLoading: false,
  isLoaded: false,
  isSaving: false,
  isNew: false,
  step: 1,
  stepEntered: 1,
  completed: false,
  teamLeader: false,
  financialAid: false,
  signedUrlPost: '',
  data: {
    step: 1,
    proofOfEnrollment: {
      dataURL: '',
      name: '',
      size: 0,
      type: ''
    },
    schoolName: '',
    schoolCity: '',
    schoolState: '',
    schoolCountry: '',
    closeProximity: false,
    expectedGraduationMonth: '',
    expectedGraduationYear: '',
    // interestAnimation: false,
    // interestProductionDesign: false,
    // interestTechnical: false,
    // interestWeb: false,
    // interestDesign: false,
    // interestMarketing: false,
    // interestGaming: false,
    // otherInterests: '',
    haveNotAttended: false,
    haveAttended: false,
    haveVolunteered: false,
    yearsVolunteered: [],
    haveAttendedAsia: false,
    haveVolunteeredAsia: false,
    yearsVolunteeredAsia: [],
    // firstChoice: '',
    // secondChoice: '',
    // timeZone: '',
    firstReferenceType: '',
    firstReferenceFirstName: '',
    firstReferenceLastName: '',
    firstReferenceEmail: '',
    secondReferenceType: '',
    secondReferenceFirstName: '',
    secondReferenceLastName: '',
    secondReferenceEmail: '',
    // knowledgeFinalCutPro: '',
    // knowledgeAdobePremiere: '',
    // knowledgeAdobeAfterEffects: '',
    // knowledgeAdobePhotoshop: '',
    // knowledgeAdobeIllustrator: '',
    // knowledgeCanva: '',
    // knowledgeClosedCaptioningVideos: '',
    // shirtSize: '',
    // diet: [],
    // otherDiet: '',
    essay1: '',
    essay2: '',
    essay3: '',
    financialAidSummary: '',
    primaryTransport: '',
    airportCode: '',
    financialAidExpenses: '',
    estimatedTravelCost: '',
    fundedTravel: false,
    teamLeaderEssay1: '',
    teamLeaderEssay2: '',
    otherComments: '',
    acceptedTerms: false,
    acceptedMediaRelease: false,
    acceptedPrivacy: false
  },
  statusId: null,
  TLAppDeadline: '2024-01-19T22:00Z'
})

const fieldNames = {
  proofOfEnrollment: 'Proof Of Enrollment',
  schoolName: 'School Name',
  schoolCity: 'School City',
  schoolState: 'School State',
  schoolCountry: 'School Country',
  expectedGraduationMonth: 'Expected Month of Graduation',
  expectedGraduationYear: 'Expected Year of Graduation',
  firstReferenceType: 'First Reference Type',
  firstReferenceFirstName: 'First Reference First Name',
  firstReferenceLastName: 'First Reference Last Name',
  firstReferenceEmail: 'First Reference Email',
  secondReferenceType: 'Second Reference Type',
  secondReferenceFirstName: 'Second Reference First Name',
  secondReferenceLastName: 'Second Reference Last Name',
  secondReferenceEmail: 'Second Reference Email',
  knowledgeFinalCutPro: 'Technical Knowledge - Final Cut Pro',
  knowledgeAdobePremiere: 'Technical Knowledge - Adobe Premiere',
  knowledgeAdobeAfterEffects: 'Technical Knowledge - Adobe After Effects',
  knowledgeAdobePhotoshop: 'Technical Knowledge - Adobe Photoshop',
  knowledgeAdobeIllustrator: 'Technical Knowledge - Adobe Illustrator',
  knowledgeCanva: 'Technical Knowledge - Canva',
  knowledgeClosedCaptioningVideos: 'Technical Knowledge - Closed Captioning Videos',
  essay1: 'First Essay',
  essay2: 'Second Essay',
  essay3: 'Third Essay',
  financialAidSummary: 'Financial Aid Summary',
  primaryTransport: 'Primary Mode of Transportation',
  airportCode: 'Airport Code',
  financialAidExpenses: 'List of Travel Expenses',
  estimatedTravelCost: 'Estimated Travel Cost',
  teamLeaderEssay1: 'First Team Leader Essay',
  teamLeaderEssay2: 'Second Team Leader Essay',
  otherComments: 'Additional Comments',
  acceptedTerms: 'Acceptance of Terms',
  acceptedMediaRelease: 'Acceptance of Media Release Agreement',
  acceptedPrivacy: 'Acceptance of ACM Privacy Policy',
  shirtSize: 'T-Shirt Size'
}

const application = {
  namespaced: true,
  state: initState(),
  mutations: {
    loading (state) {
      state.isLoading = true
    },
    appLoaded (state, { data, step, completed, teamLeader, financialAid, statusId, status }) {
      state.isLoading = false
      state.isLoaded = true
      state.step = step
      state.completed = completed
      state.teamLeader = teamLeader
      state.financialAid = financialAid
      state.statusId = statusId
      state.status = status
      state.data = Object.assign(initState().data, data)
    },
    saving (state) {
      state.isSaving = true
    },
    appSaved (state) {
      state.isSaving = false
    },
    appLoadedInit (state) {
      state.isLoading = false
      state.isLoaded = true
      state.isNew = true
    },
    signedUrlPost (state, url) {
      state.signedUrlPost = url
    },
    fileUploaded (state, file) {
      state.data.proofOfEnrollment = file
    },
    appClearData (state) {
      const init = initState()
      Object.keys(init).forEach(key => { state[key] = init[key] })
    },
    updateField (state, { name, value }) {
      state.data[name] = value
    },
    removeProofOfEnrollment (state) {
      const init = initState().data.proofOfEnrollment
      Object.keys(init).forEach(key => { state.data.proofOfEnrollment[key] = init[key] })
    },
    updateFinancialAid (state, value) {
      state.financialAid = value
    },
    updateTeamLeader (state, value) {
      state.teamLeader = value
    },
    stepEntered (state, step) {
      state.stepEntered = step
    },
    updateStep (state, step) {
      state.step = step
      state.data.step = step
    },
    complete (state) {
      state.data.acceptedTerms = true
      state.data.acceptedMediaRelease = true
      state.completed = true
    },
    disableTeamLeader (state) {
      state.teamLeader = false
    }
  },
  getters: {
    getProgress: (state) => {
      if (state.completed) return 100
      return Math.round(state.step * 100 / 5)
    },
    isNewApp: (state) => {
      return state.isLoaded === true && state.isNew === true
    },
    isNotNewApp: (state) => {
      return state.isLoaded === true && state.isNew === false
    },
    getDataURL: (state) => {
      if (state.data.proofOfEnrollment.dataURL !== '') {
        return state.data.proofOfEnrollment.dataURL
      }
      return pdfIcon
    },
    proofOfEnrollmentExists: (state) => {
      return state.data.proofOfEnrollment.name !== ''
    },
    proofOfEnrollmentFileSize: (state) => {
      return Math.round(state.data.proofOfEnrollment.size / 1000000 * 100) / 100
    },
    getExpectedGraduationMonth: (state) => {
      return months.find(row => {
        return row.value === state.data.expectedGraduationMonth
      })
    },
    getExpectedGraduationYear: (state) => {
      return state.data.expectedGraduationYear
    },
    getYearsVolunteered: (state) => {
      return state.data.yearsVolunteered
    },
    getYearsVolunteeredAsia: (state) => {
      return state.data.yearsVolunteeredAsia
    },
    financialAidAndFlying: (state) => {
      return state.financialAid && state.data.primaryTransport === 'plane'
    },
    getVolunteerTypePrefFirst: (state) => {
      return state.data.firstChoice
    },
    getVolunteerTypePrefSecond: (state) => {
      return state.data.secondChoice
    },
    getTimeZone: (state) => {
      return state.data.timeZone
    },
    invalidFields: (state) => {
      let init = initState()
      let invalidFields = Object.keys(init.data).filter(key => {
        switch (key) {
          case 'step':
          case 'closeProximity':
          case 'interestAnimation':
          case 'interestProductionDesign':
          case 'interestTechnical':
          case 'interestWeb':
          case 'interestDesign':
          case 'interestMarketing':
          case 'interestGaming':
          case 'otherInterests':
          case 'haveNotAttended':
          case 'haveAttended':
          case 'haveVolunteered':
          case 'yearsVolunteered':
          case 'haveAttendedAsia':
          case 'haveVolunteeredAsia':
          case 'yearsVolunteeredAsia':
          case 'acceptedTerms':
          case 'acceptedMediaRelease':
          case 'acceptedPrivacy':
          case 'otherComments':
          case 'diet':
          case 'fundedTravel':
            return false
          case 'proofOfEnrollment':
            return init.data[key].name === state.data[key].name
          case 'financialAidSummary':
          case 'primaryTransport':
          case 'financialAidExpenses':
          case 'estimatedTravelCost':
            return state.financialAid && init.data[key] === state.data[key]
          case 'airportCode':
            return state.financialAid && state.primaryTransport === 'plane' && init.data[key] === state.data[key]
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && init.data[key] === state.data[key]
          default:
            return init.data[key] === state.data[key]
        }
      })
      let fields = []
      invalidFields.forEach(key => {
        fields.push(fieldNames[key])
      })
      return fields
    },
    isValid: (state) => {
      let init = initState()
      let invalidFields = Object.keys(init.data).filter(key => {
        switch (key) {
          case 'step':
          case 'closeProximity':
          case 'interestAnimation':
          case 'interestProductionDesign':
          case 'interestTechnical':
          case 'interestWeb':
          case 'interestDesign':
          case 'interestMarketing':
          case 'interestGaming':
          case 'otherInterests':
          case 'haveNotAttended':
          case 'haveAttended':
          case 'haveVolunteered':
          case 'yearsVolunteered':
          case 'haveAttendedAsia':
          case 'haveVolunteeredAsia':
          case 'yearsVolunteeredAsia':
          case 'diet':
          case 'otherDiet':
          case 'acceptedTerms':
          case 'acceptedMediaRelease':
          case 'acceptedPrivacy':
          case 'otherComments':
          case 'fundedTravel':
            return false
          /* case 'timeZone':
            return (state.data.firstChoice === 'Virtual' || state.data.secondChoice === 'Virtual') && state.data[key] === init.data[key]
          case 'shirtSize':
            return (state.data.firstChoice === 'In-person' || state.data.secondChoice === 'In-person') && state.data[key] === init.data[key] */
          case 'financialAidSummary':
          case 'primaryTransport':
          case 'financialAidExpenses':
          case 'estimatedTravelCost':
            return state.financialAid && init.data[key] === state.data[key]
          case 'airportCode':
            return state.financialAid && state.primaryTransport === 'plane' && init.data[key] === state.data[key]
          case 'proofOfEnrollment':
            return init.data[key].name === state.data[key].name
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && init.data[key] === state.data[key]
          default:
            return init.data[key] === state.data[key]
        }
      })
      console.log(invalidFields)
      return invalidFields.length === 0
    },
    isOverWordCount: (state) => {
      let init = initState()
      let invalidFields = Object.keys(init.data).filter(key => {
        switch (key) {
          case 'financialAidSummary':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 80
          case 'financialAidExpenses':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 30
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && state.data[key].trim().split(/\s+/).length > 250
          case 'essay1':
          case 'essay2':
          case 'essay3':
            return state.data[key].trim().split(/\s+/).length > 250
          default:
            return false
        }
      })
      console.log(invalidFields)
      return invalidFields.length !== 0
    },
    overWordCount: (state) => {
      let init = initState()
      let invalidFields = Object.keys(init.data).filter(key => {
        switch (key) {
          case 'financialAidSummary':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 80
          case 'financialAidExpenses':
            return state.financialAid && state.data[key].trim().split(/\s+/).length > 30
          case 'teamLeaderEssay1':
          case 'teamLeaderEssay2':
            return state.teamLeader && state.data[key].trim().split(/\s+/).length > 250
          case 'essay1':
          case 'essay2':
          case 'essay3':
            return state.data[key].trim().split(/\s+/).length > 250
          default:
            return false
        }
      })
      console.log(invalidFields)
      let fields = []
      invalidFields.forEach(key => {
        fields.push(fieldNames[key])
      })
      return fields
    },
    pastTLAppDeadline: (state) => {
      return moment().utc().isAfter(state.TLAppDeadline)
    },
    isPending: (state) => {
      return state.statusId === null
    },
    isOffered: (state) => {
      return state.statusId === 1
    },
    isAccepted: (state) => {
      return state.statusId === 2
    },
    isDeclined: (state) => {
      return state.statusId === 4
    },
    isRejected: (state) => {
      return state.statusId === 3
    }
  },
  actions: {
    load ({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        commit('loading')
        fetch(process.env.BASE_URL + 'application/' + rootState.user.profile.id,
          {
            headers: {
              'Authorization': rootState.user.session.accessToken
            }
          })
          .then(response => {
            return response.json().then(payload => {
              if (response.status === 200 && payload.success) {
                let appData = {
                  data: payload.data.data,
                  step: payload.data.data.step,
                  completed: payload.data.completed,
                  teamLeader: payload.data.team_leader,
                  financialAid: payload.data.financial_aid,
                  statusId: payload.data.sv.application_status_id,
                  status: payload.data.sv.application_status_id === null ? 'Pending' : appStatus[payload.data.sv.application_status_id - 1]
                }
                commit('appLoaded', appData)
                resolve()
              } else if (response.status === 404 && !payload.success) {
                commit('appLoadedInit')
                resolve()
              } else {
                commit('error', { message: 'Unable to load application' }, { root: true })
                resolve()
              }
            })
          }).catch(err => {
            commit('error', { message: err.message }, { root: true })
            reject(err)
          })
      })
    },
    save ({ commit, state, rootState }) {
      return new Promise((resolve, reject) => {
        commit('saving')
        let appData = {
          sv_id: rootState.user.profile.id,
          data: state.data,
          completed: state.completed,
          team_leader: state.teamLeader,
          financial_aid: state.financialAid
        }
        fetch(process.env.BASE_URL + 'application/save', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: JSON.stringify(appData)
        }).then((response) => {
          commit('appSaved')
          resolve()
        }).catch((err) => {
          commit('error', { message: err.message }, { root: true })
          reject(err)
        })
      })
    },
    getSignedUrl ({ commit, rootState }, { fileType }) {
      return new Promise((resolve, reject) => {
        fetch(process.env.BASE_URL + 'files/upload', {
          method: 'POST',
          headers: {
            'Authorization': rootState.user.session.accessToken
          },
          body: JSON.stringify({
            user_id: rootState.user.profile.svid,
            file_type: fileType
          })
        }).then(response => {
          response.json().then(payload => {
            commit('signedUrlPost', payload.data.url)
            resolve(payload.data.url)
          })
        }).catch(err => {
          commit('error', { message: err.message }, { root: true })
        })
      })
    },
    finish ({ commit, dispatch }) {
      commit('complete')
      dispatch('save').then(() => {
        router.push('/')
      })
    }
  }
}

export default application



// WEBPACK FOOTER //
// ./src/store/application.js